module.exports = __webpack_public_path__ + "65330c49e0c8abfc1c96da3ab3671ad6.png";